import "bootstrap/dist/css/bootstrap.min.css";
import * as React from "react";
import "react-notifications-component/dist/theme.css";
import { Col, Container, Row } from "reactstrap";
import { showAlert } from "../common/functions";
import RatingList from "./ratingList";

class RatingPage extends React.Component {
	componentDidMount() {
		var alertMessage = window.localStorage.getItem("alertMessage");
		if (alertMessage && alertMessage !== "") {
			showAlert(alertMessage, false);
			window.localStorage.setItem("alertMessage", "");
		}

		document.title = "DAB Rating List - Daily Audio Bible Administration";
	}

	render() {
		return (
			<div>
				<Container>
					<Row>
						<Col lg="12">
							<div>
								<h2>
									<span data-testid="ratingPageTitle">DAB Rating List</span>
								</h2>
								<hr />
								<RatingList />
							</div>
						</Col>
						<Col />
					</Row>
				</Container>
			</div>
		);
	}
}

export default RatingPage;
